import { render, staticRenderFns } from "./NoticeNoticeDel.vue?vue&type=template&id=c66fa566&scoped=true"
import script from "./NoticeNoticeDel.vue?vue&type=script&lang=js"
export * from "./NoticeNoticeDel.vue?vue&type=script&lang=js"
import style0 from "./NoticeNoticeDel.vue?vue&type=style&index=0&id=c66fa566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66fa566",
  null
  
)

export default component.exports